export type ActiveProductTag = {
  key: string;
  labelHe: string;
  color: string | null;
};

const FALLBACK_TONES = 8;

function hashKey(key: string): number {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return hash % FALLBACK_TONES;
}

function isHexColor(value: string | null | undefined): value is string {
  return Boolean(value && /^#[0-9a-fA-F]{6}$/.test(value));
}

/** Soft tint from a solid #RRGGBB for tag backgrounds. */
function softBackground(hex: string): string {
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, 0.18)`;
}

export function parseActiveProducts(value: unknown): ActiveProductTag[] {
  if (!Array.isArray(value)) {
    return [];
  }
  const tags: ActiveProductTag[] = [];
  for (const item of value) {
    if (!item || typeof item !== "object") {
      continue;
    }
    const record = item as Record<string, unknown>;
    const key = String(record.key ?? "").trim();
    const labelHe = String(record.labelHe ?? "").trim();
    if (!key || !labelHe) {
      continue;
    }
    const colorRaw = record.color;
    const color =
      typeof colorRaw === "string" && isHexColor(colorRaw) ? colorRaw : null;
    tags.push({ key, labelHe, color });
  }
  return tags;
}

export function CustomerProductTags({ tags }: { tags: ActiveProductTag[] }) {
  if (tags.length === 0) {
    return <span className="customer-product-tags__empty">—</span>;
  }
  return (
    <div className="customer-product-tags">
      {tags.map((tag) => {
        const color = isHexColor(tag.color) ? tag.color : null;
        return (
          <span
            key={tag.key}
            className={
              color
                ? "customer-product-tag"
                : `customer-product-tag customer-product-tag--${hashKey(tag.key)}`
            }
            style={
              color
                ? {
                    background: softBackground(color),
                    borderColor: color,
                    color,
                  }
                : undefined
            }
            title={tag.labelHe}
          >
            {tag.labelHe}
          </span>
        );
      })}
    </div>
  );
}
